import { render, staticRenderFns } from "./gracias_registro.vue?vue&type=template&id=79b61e84&"
import script from "./gracias_registro.vue?vue&type=script&lang=js&"
export * from "./gracias_registro.vue?vue&type=script&lang=js&"
import style0 from "./gracias_registro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports